import {generalRequest} from "../services";

export async function apiGetSharedModule(module, uuid) {
    return generalRequest.get('student/share_checker/' + module + '/' + uuid)
}